// extracted by mini-css-extract-plugin
export var carouselContainer = "D_rm d_w d_H d_bf d_Z";
export var carouselContainerCards = "D_vD D_rm d_w d_H d_bf d_Z";
export var carouselContainerSides = "D_vF d_w d_H d_Z";
export var prevCarouselItem = "D_vG d_w d_H d_0 d_k";
export var prevCarouselItemL = "D_vH D_vG d_w d_H d_0 d_k";
export var moveInFromLeft = "D_vJ";
export var prevCarouselItemR = "D_vK D_vG d_w d_H d_0 d_k";
export var moveInFromRight = "D_vL";
export var selectedCarouselItem = "D_vM d_w d_H d_Z d_bf";
export var selectedCarouselItemL = "D_vN D_vM d_w d_H d_Z d_bf";
export var selectedCarouselItemR = "D_vP D_vM d_w d_H d_Z d_bf";
export var nextCarouselItem = "D_vQ d_w d_H d_0 d_k";
export var nextCarouselItemL = "D_vR D_vQ d_w d_H d_0 d_k";
export var nextCarouselItemR = "D_vS D_vQ d_w d_H d_0 d_k";
export var arrowContainer = "D_vT d_H d_0 d_dB d_bl d_4 d_b1";
export var prevArrowContainer = "D_vV D_vT d_H d_0 d_dB d_bl d_4 d_b1";
export var prevArrowContainerHidden = "D_vW D_vV D_vT d_H d_0 d_dB d_bl d_4 d_b1 d_k";
export var nextArrowContainer = "D_vX D_vT d_H d_0 d_dB d_bl d_4 d_b1";
export var carouselContainerProducts = "D_vY";
export var nextArrowContainerHidden = "D_vZ D_vX D_vT d_H d_0 d_dB d_bl d_4 d_b1 d_k";
export var arrow = "D_kG d_0";
export var prevArrow = "D_v0 D_kG d_0";
export var nextArrow = "D_v1 D_kG d_0";
export var carouselIndicatorContainer = "D_v2 d_w d_dw d_bl d_bz d_bD d_bP d_bJ d_0";
export var btnsContainer = "D_v3 d_w d_bz d_bF";
export var carouselText = "D_v4 d_dq d_bz d_bD d_bP d_b1 d_dB d_cD";
export var carouselTextInactive = "D_v5 D_v4 d_dq d_bz d_bD d_bP d_b1 d_dB d_cD";
export var indicator = "D_v6 d_b7";
export var carouselIndicator = "D_v7 D_v6 d_b7";
export var carouselIndicatorSelected = "D_v8 D_v6 d_b7";
export var arrowsContainerTopRight = "D_v9 d_0 d_bl d_bC";
export var arrowsContainerBottomLeft = "D_wb d_0 d_bl d_bC";
export var arrowsContainerSides = "D_wc d_0 d_bl d_bC";
export var smallArrowsBase = "D_wd d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var smallArrowContainer = "D_wf D_wd d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var smallArrowContainerPrev = "D_wg D_wf D_wd d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var smallArrowContainerSmall = "D_wh D_wd d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var smallArrowContainerPrevSmall = "D_wj D_wh D_wd d_bT d_bz d_bD d_bP d_b1 d_dB d_cD";
export var icon = "D_qK";
export var iconSmall = "D_wk";
export var multipleWrapper = "D_wl d_bC d_bF d_bf";
export var multipleImage = "D_wm d_bC";
export var sidesPrevContainer = "D_wn D_wf D_wd d_bT d_bz d_bD d_bP d_b1 d_dB d_cD d_fn d_0 d_bl d_cD";
export var sidesNextContainer = "D_wp D_wf D_wd d_bT d_bz d_bD d_bP d_b1 d_dB d_cD d_fn d_0 d_bl d_cD";